import { useGoogleLogin, CodeResponse } from '@react-oauth/google';

import { AuthActions, useAuthDispatch } from '@wajeez-web/stores/auth';

export const useLoginWithGoogle = () => {
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => responseGoogle(tokenResponse),
    flow: 'auth-code',
  });
  const dispatch = useAuthDispatch();

  const responseGoogle = (tokenResponse: CodeResponse) => {
    if (
      tokenResponse !== null &&
      tokenResponse !== undefined &&
      tokenResponse.code
    ) {
      dispatch(
        AuthActions.signInWithGoogleAsync({
          token: tokenResponse.code,
        })
      );
    }
  };

  return { login };
};
